import React, { useState, useCallback } from 'react';
import { Box, Text, Button } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { nextStep } from '../../store/formSlice';
import StepHeader from './StepHeader';
import { register } from '../../collection/ApiCollection';
import { toast } from 'react-toastify';
import { authtemplogin } from '../../store/Authentication';

const FinalStep = React.memo(() => {
    const dispatch = useDispatch();
    const { signUpData, formData: { firstName } } = useSelector((state) => state.form);
    const [loading, setLoading] = useState(false);

    const handleSubmit = useCallback(async () => {
        setLoading(true);
        const isEmail = !!signUpData.email;
        const payload = isEmail
            ? {
                email: signUpData.email,
                fullName: signUpData.fullName,
                password: signUpData.password,
                confirmPassword: signUpData.confirmPassword,
            }
            : {
                fullName: signUpData.fullName,
                password: signUpData.password,
                confirmPassword: signUpData.confirmPassword,
                phoneNumber: signUpData.phoneNumber,
                countryCode: signUpData.countryCode,
            };
        try {
            const res = await register(payload);
            toast.success(res?.message);
            dispatch(authtemplogin(res?.data?.data));
            dispatch(nextStep());
        } catch (err) {
            toast.error(
                err?.response?.data?.message ||
                err?.error ||
                err?.message ||
                "Something went wrong"
            );
        } finally {
            setLoading(false);
        }
    }, [signUpData, dispatch]);

    return (
        <Box maxW={{ base: '100%', md: '2xl' }} mx="auto" p={{ base: 4, md: 6 }} textAlign="center">
            <StepHeader
                title="Final Step Before Signup"
                subtitle="Thank you!"
            />
            <Text
                fontSize={{ base: '18px', md: '24px' }}
                color="black"
                mb={4}
                fontFamily="Nunito"
            >
                "You're about to make a real difference in{' '}
                <Text as="span" color="brand.500" fontWeight="semibold" display="inline">
                    {firstName ? firstName : 'First Name'}
                </Text>
                's life."
            </Text>
            <Text fontSize={{ base: '16px', md: '18px' }} color="gray.700" mb={6}>
                Let's create your account and get started.
            </Text>
            <Button
                mt={4}
                px="30px"
                onClick={handleSubmit}
                isLoading={loading}
                isDisabled={loading}
            >
                Create My Account
            </Button>
        </Box>
    );
});

export default FinalStep;
